import React from 'react';
import { Box, PopoverOrigin, Typography } from '@mui/material';
import { cs as czech } from 'date-fns/locale/cs';
import dayjs from 'dayjs';
import { DateRange, DayPicker } from 'react-day-picker';

import { ValueSelector } from '@/components';
import palette from '@/theme/palette';

import { styles } from './styles';

type TDateSelectorProps = {
  rangeState: [DateRange | undefined, (value?: DateRange) => void];
  dateRangeFilterPopoverProps: [
    undefined | HTMLElement,
    (dateRangeFilterPopover?: undefined | HTMLElement) => void,
  ];
  anchorOrigin?: PopoverOrigin;
};

export const DateSelector = ({
  rangeState: [range, setRange],
  dateRangeFilterPopoverProps: [dateRangeFilterPopover, setDateRangeFilterPopover],
  anchorOrigin = { vertical: 'top', horizontal: 'right' },
}: TDateSelectorProps) => {
  return (
    <ValueSelector
      handleClear={() => setRange(undefined)}
      anchorEl={dateRangeFilterPopover}
      setAnchorEl={setDateRangeFilterPopover}
      anchorOrigin={anchorOrigin}
    >
      <Box sx={styles.datePicker}>
        <Typography
          variant="subtitle1"
          color={palette.text.secondary}
          sx={{ ml: '10px', mt: '5px' }}
        >
          {range?.from && dayjs(range?.from).format('DD.MM.YYYY')}
          {range?.to && !dayjs(range?.from).isSame(range?.to, 'day') && ' - '}
          {range?.to &&
            !dayjs(range?.from).isSame(range?.to, 'day') &&
            dayjs(range?.to).format('DD.MM.YYYY')}
        </Typography>
        <DayPicker id="test" mode="range" locale={czech} selected={range} onSelect={setRange} />
      </Box>
    </ValueSelector>
  );
};
